import { configureStore } from "@reduxjs/toolkit";
import sidebarSlice from "./Slices/SidebarSlice";
import AuthSlice from "./Slices/AuthSlice";
import ClientsSlice from "./Slices/ClientsSlice";
import AbonementsSlice from "./Slices/AbonementsSlice";
import DropDownSlice from "./Slices/DropDownSlice";
import TrainersSlice from "./Slices/Administrator/TrainersSlice";
import ClubsSlice from "./Slices/Administrator/ClubsSlice";
import ClubTypesSlice from "./Slices/Administrator/ClubTypesSlice";
import PaymentsSlice from "./Slices/Administrator/PaymentsSlice";
import BookingSlice from "./Slices/Administrator/BookingSlice";
import StocksSlice from "./Slices/Administrator/StocksSlice";
import ServicesSlice from "./Slices/Administrator/ServicesSlice";
import SlotsSlice from "./Slices/Administrator/SlotsSlice";
import ScheduleSlice from "./Slices/Administrator/ScheduleSlice";
import GymsSlice from "./Slices/Administrator/GymsSlice";
import TrainingsSlice from "./Slices/Administrator/TrainingsSlice";
import GalerySlice from "./Slices/Administrator/GalerySlice";
import SubscribesSlice from "./Slices/SubscribesSlice";
import HelperSlice from "./Slices/HelperSlice";
import MailingsSlice from "./Slices/MailingsSlice";
import VersionsSlice from "./Slices/VersionsSlice";
import ParamsSlice from "./Slices/ParamsSlice";
import PassagesSlice from "./Slices/Administrator/PassagesSlice";
import TrainingRecordsSlice from "./Slices/Administrator/TrainingRecordsSlice";
import ClubDocumentsSlice from "./Slices/Documents/ClubDocumentsSlice";
import PacketsTrainingsSlice from "./Slices/Administrator/PacketsTrainingsSlice";
import PersonalTrainingsSlice from "./Slices/Administrator/PersonalTrainingsSlice";
import TrainSchedSlice from "./Slices/Administrator/TrainSchedSlice";
import PaymentsToCoachesSlice from './Slices/Administrator/PaymentsToCoachesSlice';
import PacketsServicesSlice from './Slices/Administrator/PacketsServicesSlice';
import CertificatesSlice from './Slices/Administrator/CertificatesSlice';
import PaymentRemindersSlice from './Slices/Administrator/PaymentRemindersSlice'
import UsersRatingSlice from './Slices/UsersRatingSlice';

export const store = configureStore({
  reducer: {
    sidebarSlice,
    AuthSlice,
    ClientsSlice,
    AbonementsSlice,
    TrainersSlice,
    DropDownSlice,
    ClubsSlice,
    PaymentsSlice,
    BookingSlice,
    StocksSlice,
    ServicesSlice,
    SlotsSlice,
    ScheduleSlice,
    GymsSlice,
    PacketsTrainingsSlice,
    PersonalTrainingsSlice,
    TrainingsSlice,
    GalerySlice,
    HelperSlice,
    MailingsSlice,
    SubscribesSlice,
    VersionsSlice,
    ParamsSlice,
    PassagesSlice,
    TrainingRecordsSlice,
    ClubTypesSlice,
    ClubDocumentsSlice,
    ClubDocumentsSlice,
    TrainSchedSlice,
    PaymentsToCoachesSlice,
    PacketsServicesSlice,
    CertificatesSlice,
    PaymentRemindersSlice,
    UsersRatingSlice,
  },
});
